import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/index.css";
import App from "@/App";
import AdminPage from "@/AdminPage";
import { PrivacyPolicy, TermsOfService, RefundPolicy } from "@/LegalPages";
import ExamplePage from "@/ExamplePage";
import BlogPost, { BlogIndex } from "@/BlogPage";
import NotFoundPage from "@/NotFoundPage";
import { BrandNameGenerator, TaglineRoulette } from "@/MiniToolPage";
import BrandVibeCheckPage from "@/BrandVibeCheckPage";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<App />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/refund" element={<RefundPolicy />} />
          <Route path="/examples/:slug" element={<ExamplePage />} />
          <Route path="/blog" element={<BlogIndex />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/brand-name-generator" element={<BrandNameGenerator />} />
          <Route path="/tagline-roulette" element={<TaglineRoulette />} />
          <Route path="/brand-vibe-check" element={<BrandVibeCheckPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
